import moment from "moment";

export const getDate = (date, appLang = "en-us", format = "MMM DD h:mm A") => {
  if (!date) return "";
  const dateFormatted = moment(date).locale(appLang).format(format);

  const formNow = moment(date).locale(appLang).format("h:mm A");

  let checkIfToday = moment(date).isSame(moment(), "day");
  if (checkIfToday) {
    return formNow;
  } else {
    return dateFormatted;
  }
};
